module.exports = __webpack_public_path__ + "static/media/ds-bg-tile.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ds-bg-tile.png
// module id = 520
// module chunks = 0